exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@import url(\"https://fonts.googleapis.com/css?family=Open+Sans:bold,regular|Roboto:bold,regular,light\");\n.canopy-list-renderer {\n  border: 1px solid #efefef;\n  border-radius: 10px;\n  padding: 20px;\n  background: white; }\n.canopy-list-renderer .renderer-title {\n    font-size: 18px; }\n.report-img-holder {\n  position: relative; }\n.report-img-holder .pen {\n    opacity: 0;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=0)\";\n    filter: alpha(opacity=0);\n    -webkit-transition: all 0.2s ease-in-out;\n    transition: all 0.2s ease-in-out;\n    position: absolute;\n    bottom: 40px;\n    right: 0px; }\n.report-img-holder.complete .pen {\n    opacity: 1;\n    -ms-filter: \"progid:DXImageTransform.Microsoft.Alpha(Opacity=100)\";\n    filter: alpha(opacity=100);\n    bottom: 50px;\n    right: 5px; }\n.count-display h3 {\n  font-size: 22px;\n  margin-right: 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/components/report-dialog/report-dialog.component.scss
// module id = ../../../../../src/app/shared/components/report-dialog/report-dialog.component.scss
// module chunks = main